import { Link } from "react-router-dom";
import { categoryList } from "@/mocks/siteConfig";

export default function CategorySection() {
  return (
    <section className="w-full py-20 md:py-28 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            探索内容分类
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            按照你的需求浏览不同分类的内容，快速找到你想要的信息
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {categoryList.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-8 rounded-2xl bg-white border border-foreground-100 hover:border-foreground-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-foreground-950 text-white mb-5 group-hover:scale-110 transition-transform duration-300">
                <i className={`${cat.icon} text-2xl`} />
              </div>
              <h3 className="text-lg font-semibold text-foreground-950 mb-2 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 text-center leading-relaxed mb-4">
                {cat.description}
              </p>
              <span className="text-xs text-foreground-400">
                {cat.count} 篇文章
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}